import React from 'react';
import Icon from 'framework-ui-components/Components/Icons/Icon';

export default Icon(
  <g>
    <circle style={{ fill: '#2a9cf4' }} cx="7.73" cy="7.83" r="7.6" />
    <g>
      <g>
        <path
          style={{ fill: 'white' }}
          d="M6.66,9.89c0-0.67,0.08-1.21,0.24-1.61c0.16-0.4,0.46-0.79,0.9-1.18c0.43-0.39,0.72-0.7,0.87-0.94
			c0.14-0.24,0.22-0.5,0.22-0.77c0-0.81-0.37-1.22-1.12-1.22c-0.36,0-0.64,0.11-0.85,0.33C6.7,4.72,6.59,5.02,6.58,5.41H4.49
			C4.5,4.49,4.79,3.77,5.38,3.25c0.58-0.52,1.38-0.78,2.39-0.78c1.02,0,1.81,0.25,2.37,0.74c0.56,0.49,0.84,1.19,0.84,2.09
			c0,0.41-0.09,0.79-0.28,1.16c-0.18,0.36-0.5,0.76-0.96,1.21L9.16,8.22C8.8,8.57,8.59,8.98,8.54,9.45L8.51,9.89H6.66z M6.45,12.1
			c0-0.32,0.11-0.58,0.33-0.79C7,11.1,7.28,11,7.62,11c0.34,0,0.62,0.1,0.84,0.31c0.22,0.21,0.33,0.47,0.33,0.79
			c0,0.32-0.11,0.58-0.32,0.78c-0.21,0.21-0.49,0.31-0.85,0.31c-0.35,0-0.63-0.1-0.85-0.31C6.56,12.68,6.45,12.42,6.45,12.1z"
        />
      </g>
    </g>
  </g>, '0 0 15.47 15.66', 'AssistenteInlineIcon',
);
